import React from 'react';
// Option 1: Import from package.json directly
import packageJson from '../../package.json';
// Option 2: Import from version.js
// import version from '../config/version';

const AppVersion = () => {
  return (
    
<small className="small fw-bold py-3 mb-4">
<span className="text-muted fw-light">Version : </span> {packageJson.version}
</small>
  );
};
export default AppVersion;
